import { store } from '@/core/store';

// eslint-disable-next-line import/prefer-default-export
export class SettleFinishedCoursesCommand {
  // eslint-disable-next-line class-methods-use-this
  execute() {
    return store.dispatch('taxiCourse/settleFinishedCourses');
  }
}
